import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom';

import { updatesFetchIfNeeded } from './../store/updates/actions';
import { getUpdateListSorted } from './../store/updates/selectors';

import UpToButton from './../components/UpToButton';
import Icon from './../components/Icon';
import formatTime from './../utils/formatTime';

const COUNT_STEP = 8;

class UpdatesTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            count: COUNT_STEP
        };

        this.onMoreClick = this.onMoreClick.bind(this);
    }

    onMoreClick() {
        const { updateList } = this.props;
        this.setState(state => Object.assign({}, state, {
            count: Math.min(state.count + COUNT_STEP, updateList.length)
        }));
    }

    componentDidUpdate() {
        const { loadUpdates } = this.props;
        loadUpdates();
    }

    componentDidMount() {
        const { loadUpdates } = this.props;
        loadUpdates();
    }

    renderNextButton() {
        const { updateList, isLoading } = this.props;

        if (!updateList.length || isLoading) {
            return null;
        }

        const { count } = this.state;
        const nextCount = Math.min(updateList.length - count, COUNT_STEP);
        if (nextCount <= 0) {
            return null;
        }
        return (
            <button type="button" className="btn btn-show-next mb35" onClick={this.onMoreClick}>Show more updates</button>
        );
    }

    render() {
        
        const { isLoading, updateList } = this.props;
        const { count } = this.state;

        if (isLoading) {
            return (<div className="preloading preloading-box"><p>Loading</p></div>);
        }

        if (!updateList.length) {
            return (
                <div className="container">
                    <div className="page-not-result">
                        <span className="emoji" role="img" aria-label="">😭</span>
                        <h1>Oops, there are no update items.</h1>
                        <p className="notes">Please try again later.</p>
                    </div>
                </div>
            );
        }

        return (

            <div className="container">

                <ul className="content-item">
                    {updateList.slice(0, count).map(update => 
                        <li className="row article-item" key={update._id}>
                            <div className="col-1 article-item-image">
                                {update.thumbnail
                                    ? <Link to={`/inbox/updates/${update._id}`}><img src={update.thumbnail} alt=""/></Link>
                                    : <Link to={`/inbox/updates/${update._id}`}><Icon className="svg-icon" iconName="active-notification" /></Link>
                                }
                            </div>
                            <div className="col-7">
                                <div className="article-item-info">
                                    {update.status === 'unread' &&
                                        <span className="badge badge-new">new</span>
                                    }
                                    <span className="article-item-author">{update.author} <span className="dotted-devider">·</span> {formatTime(update.created_at, 'd')}</span>
                                </div>

                                <Link className="article-item-lnk" to={`/inbox/updates/${update._id}`}>{update.subject}</Link>
                                <p className="article-item-preview">{update.message.substring(0, 140) + '...'}</p>
                            </div>
                        </li>
                    )}
                </ul>

                <UpToButton />
                {this.renderNextButton()}
            </div>
        );
    }
};

const mapStateToProps = state => {

    const updateList = getUpdateListSorted(state);
    const isLoading = state.updates.isFetching;
    return { updateList, isLoading };
};

const mapDispatchToProps = dispatch => {
    return {
        loadUpdates: () => dispatch(updatesFetchIfNeeded())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdatesTable);



// WEBPACK FOOTER //
// ./src/components/UpdatesTable.js